import { useEffect } from 'react';

export const useKeyboardShortcuts = (handlers: {
  onToggle: () => void;
  onSkip: () => void;
  onReset: () => void;
  onToggleTasks: () => void;
  onToggleMini: () => void;
}) => {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement ||
        (e.target as HTMLElement).isContentEditable
      ) return;
      if (e.ctrlKey || e.metaKey || e.altKey) return;

      switch (e.key) {
        case ' ':
          e.preventDefault();
          handlers.onToggle();
          break;
        case 's':
        case 'S':
          handlers.onSkip();
          break;
        case 'r':
        case 'R':
          handlers.onReset();
          break;
        case 't':
        case 'T':
          handlers.onToggleTasks();
          break;
        case 'm':
        case 'M':
          handlers.onToggleMini();
          break;
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [handlers]);
};
